// Suena la campana y, en modo de voz, lo dice. No pinta nada.
//
// Existe como componente y no como llamada suelta porque necesita estar DENTRO
// de AssistantProvider: de ahí sale si el modo de voz está abierto.
import { useVoiceConversationMode } from '../../hooks/useVoiceConversationMode.js';
import { useAvisos } from '../../hooks/useAvisos.js';

export function AvisoSonoro() {
  const voice = useVoiceConversationMode();
  useAvisos({ activa: voice.phase !== 'closed' });
  return null;
}
